import { createContext, useContext } from "react";
import AuthService from "../services/authService";

const AuthContext = createContext({
  getPortals: () => ({}),
  signinRedirectCallback: () => {},
  logout: () => ({}),
  signoutRedirectCallback: () => ({}),
  isAuthenticated: () => ({}),
  signinRedirect: () => ({}),
  signinSilentCallback: () => ({}),
  createSigninRequest: () => ({}),
});

export const AuthConsumer = AuthContext.Consumer;
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h1>Browser Not Supported</h1>
        <p>
          Please use Google Chrome, Mozilla Firefox, or Microsoft Edge to access
          this website.
        </p>
      </div>
    );
  }
  return (
    <AuthContext.Provider value={AuthService}>{children}</AuthContext.Provider>
  );
}
